exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".intrinsic{display:block;position:relative;height:auto;width:100%;background:#f0f0f0}.intrinsic,.intrinsic.intrinsic--square{padding-top:100%}.intrinsic.intrinsic--4x3{padding-top:75%}.intrinsic.intrinsic--16x9{padding-top:56.25%}.intrinsic.intrinsic--12x8{padding-top:66.66667%}.intrinsic .intrinsic-item{position:absolute;top:0;left:0;width:100%;height:100%}.intrinsic .intrinsic-item.fit-me{object-fit:cover;width:inherit;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-80220024","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/shared/intrinsic.vue
// module id = 130
// module chunks = 4